import { render, staticRenderFns } from "./index.vue?vue&type=template&id=970eb61c&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "970eb61c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangmin/Projects/devidia_projects/devidia-p1-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('970eb61c')) {
      api.createRecord('970eb61c', component.options)
    } else {
      api.reload('970eb61c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=970eb61c&scoped=true&", function () {
      api.rerender('970eb61c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DwChinaZonesSelect/index.vue"
export default component.exports